import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useAppDispatch } from "../../app/hooks";
import { setURLPaths } from "../../app/appInitializeReducer";
import { RouteConstants } from "../../constants/RouteConstants";
import { useTheme } from "../../context/themeContext";
import TabDrawer from "../shared/TabDrawer/TabDrawer";
import ThemeStyling from "./ThemeStying";
import Assets from "./Assets";
import Language from "./Language";
import Policies from "./Policies";

export interface FileInfo {
  file: File;
  metadata: any;
  versioning: boolean;
  publicObject: boolean;
  issues?: Array<any>;
}

const Customization = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const [activeTab, setActiveTab] = useState(`${t("T_ASSETS")}`);

  useEffect(() => {
    const init = async () => {
      setBreadCrump();
    };
    init();
  }, []);

  const setBreadCrump = async () => {
    dispatch(
      setURLPaths([
        {
          key: RouteConstants.ROUTE_CUSTOMIZATION,
          label: `${t("T_PATIENT_REQUESTS")} > ${t("T_CUSTOMIZATION")}`,
        },
      ])
    );
  };

  const tabConfig = [
    {
      label: t("T_ASSETS"),
      component: <Assets></Assets>,
    },
    {
      label: t("T_THEME_STYLING"),
      component: <ThemeStyling></ThemeStyling>,
    },
    {
      label: t("T_LANGUAGE"),
      component: <Language></Language>,
    },
    {
      label: t("T_POLICIES"),
      component: <Policies></Policies>,
    },
  ];

  return (
    <div
      className="flex w-full flex-1 flex-row justify-start p-5"
      style={useTheme().theme.bgColorStyleForLoggedInPage}
    >
      <div
        style={{
          border: "1px solid #D9D9D9",
          borderRadius: "7px",
          overflow: "auto",
        }}
        className="flex w-full flex-1 flex-col"
      >
        <TabDrawer
          borderBottom={true}
          tabConfig={tabConfig}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
      </div>
    </div>
  );
};

export default Customization;
